export default __webpack_public_path__ + "static/media/startupStudio.641f289f.svg";